import to from "await-to-js"
import React from "react"
import { SubmitHandler } from "react-hook-form"
import { useNavigate } from "react-router-dom"
import WebinarCategoryManagementForm, {
  WebinarCategoryForm,
} from "../../../components/cms/WebinarCategoryManagementForm"
import EmployeeDashboardWrapper from "../../../components/layouts/EmployeeDashboardWrapper"
import DefBreadcrumb from "../../../components/ui/breadcrumb/DefBreadcrumb"
import api from "../../../utils/axiosInstance"
import { getCMSSegments } from "../../../utils/helper"
import {
  CMSCreateWebinarCategoryResponse,
  GeneralAPIValidationResponse,
  ProductCategory,
} from "../../../utils/types"

const WebinarCategoryManagementCreate: React.FC = () => {
  const segments = getCMSSegments()
  const navigate = useNavigate()
  const [serverValidationError, setServerValidation] = React.useState<{
    name: string | undefined
    description: string | undefined
  }>({
    name: undefined,
    description: undefined,
  })

  const [webinarCategorySubmitting, setWebinarCategorySubmit] =
    React.useState(false)

  const webinarCategoryCreateSubmitHandler: SubmitHandler<
    WebinarCategoryForm
  > = async (data) => {
    setWebinarCategorySubmit(true)

    const [err, _] = await to<
      CMSCreateWebinarCategoryResponse<ProductCategory>,
      GeneralAPIValidationResponse
    >(api.cms.createWebinarCategory(data))
    if (err) {
      const validationResponse: {
        name: string | undefined
        description: string | undefined
      } = { ...serverValidationError }

      Object.keys(validationResponse).forEach((field) => {
        const errMessages: string[] | undefined = err.errors![field]

        if (errMessages === undefined) return

        const message = (errMessages as string[]).join(". ")

        validationResponse[field] = message
      })

      setServerValidation(validationResponse)

      setWebinarCategorySubmit(false)

      return
    }

    navigate("/cms/master/webinar-category", {
      state: { webinarCategoryUpsertSuccess: true },
    })
  }

  return (
    <EmployeeDashboardWrapper>
      <DefBreadcrumb
        prefix="cms"
        segments={segments}
      />
      <h2 className="text-xl text-primary font-semibold leading-loose tracking-wide">
        Tambah Kategori Webinar
      </h2>
      <WebinarCategoryManagementForm
        method="POST"
        onSubmitHandler={webinarCategoryCreateSubmitHandler}
        serverValidationResponse={serverValidationError}
        submitting={webinarCategorySubmitting}
      />
    </EmployeeDashboardWrapper>
  )
}

export default WebinarCategoryManagementCreate
